__turbopack_context__.v({
  "actions": "CategoryNavigationTiles-module-scss-module__D_qs9q__actions",
  "buttonGroup": "CategoryNavigationTiles-module-scss-module__D_qs9q__buttonGroup",
  "carouselHeader": "CategoryNavigationTiles-module-scss-module__D_qs9q__carouselHeader",
  "carouselInner": "CategoryNavigationTiles-module-scss-module__D_qs9q__carouselInner",
  "contained": "CategoryNavigationTiles-module-scss-module__D_qs9q__contained",
  "grid": "CategoryNavigationTiles-module-scss-module__D_qs9q__grid",
  "gridHeading": "CategoryNavigationTiles-module-scss-module__D_qs9q__gridHeading",
  "gridItem": "CategoryNavigationTiles-module-scss-module__D_qs9q__gridItem",
  "gridLayout": "CategoryNavigationTiles-module-scss-module__D_qs9q__gridLayout",
  "gridShopAll": "CategoryNavigationTiles-module-scss-module__D_qs9q__gridShopAll",
  "heading": "CategoryNavigationTiles-module-scss-module__D_qs9q__heading",
  "root": "CategoryNavigationTiles-module-scss-module__D_qs9q__root",
  "slide": "CategoryNavigationTiles-module-scss-module__D_qs9q__slide",
  "status": "CategoryNavigationTiles-module-scss-module__D_qs9q__status",
  "swiper": "CategoryNavigationTiles-module-scss-module__D_qs9q__swiper",
  "track": "CategoryNavigationTiles-module-scss-module__D_qs9q__track",
});
